
































import { Component, Vue } from 'vue-property-decorator';
import SignUp from '@/components/SignUp.vue';
import store from '@/store';

@Component({
  components: {
    SignUp,
  },
})
export default class SignUpView extends Vue {
  get loggedIn() {
    return store.getters['auth/authenticated'];
  }

  public created() {
    if (this.loggedIn) {
      this.$router.push('/selectGame?mode=play');
    }
  }

  public onSignedUp() {
    this.$router.push('/selectGame?mode=play');
  }

  public onShowLogin() {
    this.$router.push('/login');
  }
}
